/*
*@Author: dcl
*@Description: 信息披露主页
*@Date: 2022-11-14 11:21:51
*/
<template>
    <div class="i-box">
        <div class="box-img">
            <!-- <div class="img-con"> -->
            <!-- <el-image class="con-img" :src="info_1" fit="cover" /> -->
            <div class="con-txt">
                <div class="txt-zw">公开信息披露</div>
                <div class="txt-yw">INFO DISCLOSURE</div>
            </div>
            <!-- </div> -->
        </div>
        <div class="box-content">
            <nav class="content-nav">
                <div class="nav-title">INFO DISCLOSURE</div>
                <div class="nav-list">
                    <div :ref="'info' + index" class="list-info" v-for="(item, index) in infoList" :key="index + 'infoList'"
                        @click="changeItem(item.name, item.nameE, index)">
                        <div :ref="'pot' + index" class="info-pot"></div>
                        <div class="info-txt">{{ item.name }}</div>
                    </div>
                    <transition name="fade">
                        <div
                            v-if="current == 'onlineIns' || current == 'proprietary' || current == 'cooperation' || current == 'support' || current == 'complain'">
                            <div :ref="'infoChi' + oIndex" class="info-online"
                                v-for="(oItem, oIndex) in infoList[infoList.length - 1].children" :key="oIndex + 'children'"
                                @click="changeItemChi(oItem.name, oItem.nameE, oIndex)">
                                <div :ref="'potChi' + oIndex" class="info-pot"></div>
                                <div class="info-txt">{{ oItem.name }}</div>
                            </div>
                        </div>
                    </transition>
                </div>
            </nav>
            <div class="content-con">
                <div class="con-title">
                    <!-- <div class="title-pot"></div> -->
                    <div class="title-txt">{{ currentName }}</div>
                    <!-- <div class="title-line"></div> -->
                </div>
                <div class="con-sec">
                    <Board v-if="current === 'board'" />
                    <Base v-else-if="current === 'base'" />
                    <!-- <Business v-else-if="current === 'business'" /> -->
                    <!-- <License v-else-if="current === 'license'" /> -->
                    <Branch v-else-if="current === 'branch'" />
                    <Complain v-else-if="current === 'complain'" />
                    <Proprietary v-else-if="current === 'proprietary'" />
                    <Cooperation v-else-if="current === 'cooperation'" />
                    <Relation v-else-if="current === 'relation'" />
                    <Support v-else />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Board from "./board.vue";
import Base from "./base.vue";
import Business from "./business.vue";
import License from "./license.vue";
import Branch from "./branch.vue";
import Complain from "./complain.vue";
import Proprietary from "./proprietary.vue";
import Cooperation from "./cooperation.vue";
import Relation from "./relation.vue";
import Support from "./support.vue";
export default {
    components: {
        Board,
        Base,
        Business,
        License,
        Branch,
        Complain,
        Proprietary,
        Cooperation,
        Relation,
        Support
    },
    data() {
        return {
            currentName: "机构基本信息",
            current: "base",
            info_1: require("../../assets/info_1.jpg"),
            infoList: [{
                name: "公示栏",
                nameE: "board"
            },
            {
                name: "机构基本信息",
                nameE: "base"
            },
            // {
            //     name: "营业执照",
            //     nameE: "business"
            // },
            // {
            //     name: "经营许可证",
            //     nameE: "license"
            // },
            {
                name: "分支机构",
                nameE: "branch"
            },
            {
                name: "互联网保险",
                nameE: "onlineIns",
                children: [{
                    name: "自营平台信息",
                    nameE: "proprietary"
                },
                {
                    name: "合作保险公司信息披露",
                    nameE: "cooperation"
                },
                {
                    name: "互联网保险产品",
                    nameE: "support"
                },
                {
                    name: "客户服务及投诉举报",
                    nameE: "complain"
                }]
            },

                // {
                //   name: "联系我们",
                //   nameE: "relation"
                // }
            ]
        };
    },
    mounted() {
        this.$refs['info1'][0].style.backgroundColor = '#FF9600'
        this.$refs['info1'][0].style.color = '#FFFFFF'
        this.$refs['info1'][0].style.color = '#FFFFFF'
        this.$refs['pot1'][0].style.backgroundColor = '#FFFFFF'
    },
    methods: {
        changeItem(name, v, i) {
            this.currentName = name
            this.current = v
            for (let j = 0; j < this.infoList.length; j++) {
                this.$refs['info' + j][0].style.backgroundColor = 'rgb(255, 255, 255)'
                this.$refs['info' + j][0].style.color = '#2c3e50'
                this.$refs['pot' + j][0].style.backgroundColor = '#C1C1C1'
            }
            if (v != 'onlineIns') {
                this.$refs['info' + i][0].style.backgroundColor = '#FF9600'
                this.$refs['info' + i][0].style.color = '#FFFFFF'
                this.$refs['pot' + i][0].style.backgroundColor = '#FFFFFF'
            }
            setTimeout(() => {
                if (v == 'onlineIns') {
                    this.changeItemChi('自营平台信息', 'proprietary', 0)
                    return
                }
            }, 0)
        },
        changeItemChi(name, v, i) {
            this.currentName = name
            this.current = v
            for (let j = 0; j < this.infoList[this.infoList.length - 1].children.length; j++) {
                this.$refs['infoChi' + j][0].style.backgroundColor = 'rgb(255, 255, 255)'
                this.$refs['infoChi' + j][0].style.color = '#2c3e50'
                this.$refs['potChi' + j][0].style.backgroundColor = '#C1C1C1'
            }
            this.$refs['infoChi' + i][0].style.backgroundColor = '#FF9600'
            this.$refs['infoChi' + i][0].style.color = '#FFFFFF'
            this.$refs['potChi' + i][0].style.backgroundColor = '#FFFFFF'
        }
    }
};
</script>

<style lang="less" scoped>
.i-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    text-align: left;

    .box-img {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 100%;
        color: #ffffff;
        background: url('../../assets/info_1.jpg') no-repeat center;
        background-size: cover;
        width: 100%;
        height: 12.47rem;
        max-width: 1920px;

        .con-txt {
            position: absolute;
            bottom: 2.37rem;
            left: 4.97rem;
            padding: 0rem 0.97rem 0.23rem;
            background: rgba(0, 0, 0, 0.25);

            .txt-zw {
                font-size: 2rem;
            }

            .txt-yw {
                font-size: 1.2rem;
            }
        }
    }

    .box-content {
        display: flex;
        flex-direction: row;
        width: 100%;
        max-width: 1920px;
        // margin: auto;

        .content-nav {
            display: flex;
            flex-direction: column;
            margin: .5rem 0px 0px 4.97rem;
            font-size: 0.53rem;

            .nav-title {
                margin: 0px 0px .4rem;
                font-size: 0.8rem;
                color: #EFF0F2;
                position: relative;
                top: 2rem;
            }

            .nav-title::before {
                content: '信息披露专栏';
                font-size: 1.13rem;
                color: #636363;
                position: absolute;
                top: -.97rem;
                left: 0;
            }

            .nav-list {
                display: flex;
                flex-direction: column;
                border: 1px solid #ccc;
                font-size: .53rem;
                margin-top: 2rem;

                .list-info {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: .57rem 0px;
                    cursor: pointer;
                    border-bottom: 1px dashed #cccccc;


                    .info-pot {
                        margin: 0px .87rem;
                        width: 0.27rem;
                        height: 0.07rem;
                        background: #C1C1C1;
                        // border-bottom: 5px solid transparent;
                        // border-left: 10px solid #006bb5;
                    }

                    .info-txt {
                        padding-right: .5rem;
                    }

                }

                .info-online {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: .37rem 0rem;
                    cursor: pointer;
                    border-bottom: 1px dashed #cccccc;

                    .info-pot {
                        margin: 0 .57rem 0 1.2rem;
                        width: 0.27rem;
                        height: 0.07rem;
                        background: #C1C1C1;
                        // border-bottom: 5px solid transparent;
                        // border-left: 10px solid #006bb5;
                    }

                    .info-txt {
                        padding-right: .5rem;
                    }
                }
            }
        }

        .content-con {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            margin: 1.7rem 1.93rem 0 1.93rem;

            .con-title {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 0.87rem;
                padding-bottom: .13rem;
                border-bottom: 0.27rem solid #FF9600;

                // overflow: hidden;
                // .title-pot {
                //     width: 12px;
                //     height: 35px;
                //     background-color: #006bb4;
                //     margin-right: 10px;
                // }

                // .title-line {
                //     flex: 1;
                //     height: 30px;
                //     margin-left: 5px;
                //     align-items: flex-end;
                //     // width: 100%;
                //     border-bottom: 1px solid #cccccc;
                // }
            }

            .con-sec {
                width: 100%;
            }
        }
    }
}

.fade-enter-active {
    transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Information/index.vue